import { useEffect } from 'react';
import { useThree } from '@react-three/fiber';

export function getDevicePerformanceTier() {
  if (typeof window === 'undefined') return 'high';
  
  const isMobile = window.innerWidth < 768;
  const logicalCores = navigator.hardwareConcurrency || 4;
  
  if (isMobile || logicalCores <= 4) {
    return 'low';
  } else if (logicalCores <= 8) {
    return 'medium';
  }
  
  return 'high';
}

export default function MobileOptimizer() {
  const { gl } = useThree();
  
  useEffect(() => {
    const tier = getDevicePerformanceTier();
    
    if (tier === 'low') {
      // Limit pixel ratio on low-end devices
      gl.setPixelRatio(Math.min(window.devicePixelRatio, 1.5));
    } else if (tier === 'medium') {
      gl.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    }
  }, [gl]);
  
  return null;
}
